import { Modal, ModalOverlay, ModalContent, Text, ModalCloseButton, ModalBody, Heading } from '@chakra-ui/react'
import { Image } from '@/components/HOC/Image'
import Mines5 from '@/public/assets/images/mines/wizzard-5.png'

export const MinesContestModal = ({ onClose }: { onClose: () => void }) => {
  return (
    <Modal size={'lg'} isOpen={true} onClose={onClose}>
      <ModalOverlay />
      <ModalContent marginLeft={2.5} marginRight={2.5}>
        <ModalCloseButton onClick={onClose} size="sm" />
        <ModalBody pb={5} pt={10}>
          <MinesContest />
        </ModalBody>
      </ModalContent>
    </Modal>
  )
}

const MinesContest = () => {
  return (
    <>
      <Image mb={4} rounded={'2xl'} src={Mines5} alt="" />
      <Heading userSelect={'none'} fontSize={'32px'} mb={2}>
        Win an Extra 10 Inj!
      </Heading>
      <Text userSelect={'none'} fontWeight={500} fontSize={'sm'} color={'ninja.100'} mb={1}>
        Join us in celebrating the launch of the fifth game in our series with a special contest!
      </Text>
      <Text userSelect={'none'} fontWeight={700} fontSize={'sm'} color={'ninja.100'} mb={1}>
        In Mines, you have the chance to multiply your winnings by up to x500. The first player to reach the x500
        multiplier will win an extra 10 INJ!{' '}
      </Text>

      <Text userSelect={'none'} fontWeight={500} fontSize={'sm'} color={'ninja.100'}>
        Don't wait - someone else might claim the prize before you do! Good luck!
      </Text>
    </>
  )
}
